export const nextButton = (t) => ({
  text: t('tour.buttons.next'),
  action() {
    return this.next();
  },
});

export const backButton = (t) => ({
  text: t('tour.buttons.back'),
  action() {
    return this.back();
  },
});

export const finishButton = (t) => ({
  text: t('tour.done.finish'),
  action() {
    return this.complete();
  },
});

/**
 * beforeShowPromise helper — opens a toggle panel before the step appears.
 * @param {string} panelSelector  data-tour selector of the panel to reveal  (e.g. '[data-tour="pollutants"]')
 * @param {string} btnSelector    data-tour selector of the toggle button     (e.g. '[data-tour="map-pollutant-btn"]')
 * @param {number} delay          ms to wait for React to re-render (default 200)
 */
export function openPanel(panelSelector, btnSelector, delay = 200) {
  return () =>
    new Promise((resolve) => {
      const panel = document.querySelector(panelSelector);
      if (!panel) {
        document.querySelector(btnSelector)?.click();
        setTimeout(resolve, delay);
      } else {
        resolve();
      }
    });
}

/**
 * when.hide helper — closes a toggle panel when leaving the step.
 * @param {string} panelSelector  data-tour selector of the panel to close
 * @param {string} btnSelector    data-tour selector of the toggle button
 */
export function closePanel(panelSelector, btnSelector) {
  return {
    hide() {
      const panel = document.querySelector(panelSelector);
      if (panel) {
        document.querySelector(btnSelector)?.click();
      }
    },
  };
}